import appApi from "@/app/api";
import { PAYMENT_SERVICE_BASE_URL } from "@/data/urls";
import { TCloudAPIResponse } from "@/types/app";
import { CHECKOUT_SERVICE_BASE_URL } from "../constants.checkout";

const APIURL = `${CHECKOUT_SERVICE_BASE_URL}/subscription/reactivate`;
const APIURL_V1 = `${PAYMENT_SERVICE_BASE_URL}/subscription/resume-cancel`;

export interface ReactivatePlanData {
  message: string;
  //   reactivate_timestamp: number;
  success: boolean;
}

interface ReactivatePlanOption {
  token: string;
  isV1?: boolean;
}

type TResponse = TCloudAPIResponse<ReactivatePlanData>;

export async function handleReactivatePlan(
  option: ReactivatePlanOption,
): Promise<ReactivatePlanData> {
  const headers = {
    Authorization: "Bearer " + option.token,
    "Content-Type": "application/json",
  };

  try {
    if (option.isV1) {
      const response = await appApi.post(APIURL_V1, null, { headers });
      return response.data;
    } else {
      const response = await appApi.get(APIURL, { headers });
      const res = response.data as TResponse;
      return res.data;
    }
  } catch (error: any) {
    console.error("Error reactivating plan:", error);
    throw error;
  }
}
